"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
function setChallenge(betValue) {
    return {
        type: types_1.SET_CHALLENGE_VALUE,
        payload: betValue
    };
}
exports.setChallenge = setChallenge;
function resetChallenge() {
    return {
        type: types_1.RESET_CHALLENGE_VALUE
    };
}
exports.resetChallenge = resetChallenge;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/challenges/actions.ts
// module id = 187
// module chunks = 5